import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api';

export const getContents = createAsyncThunk('content/getContents', async (params = {}, { rejectWithValue }) => {
  try {
    const response = await api.get('/content', { params });
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const getContent = createAsyncThunk('content/getContent', async (slug, { rejectWithValue }) => {
  try {
    const response = await api.get(`/content/${slug}`);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const createContent = createAsyncThunk('content/createContent', async (data, { rejectWithValue }) => {
  try {
    const response = await api.post('/content', data);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const updateContent = createAsyncThunk('content/updateContent', async ({ id, data }, { rejectWithValue }) => {
  try {
    const response = await api.put(`/content/${id}`, data);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const deleteContent = createAsyncThunk('content/deleteContent', async (id, { rejectWithValue }) => {
  try {
    await api.delete(`/content/${id}`);
    return id;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

const contentSlice = createSlice({
  name: 'content',
  initialState: {
    contents: [],
    currentContent: null,
    pagination: { page: 1, limit: 10, total: 0, pages: 0 },
    isLoading: false,
    error: null
  },
  reducers: {
    clearCurrentContent: (state) => {
      state.currentContent = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getContents.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getContents.fulfilled, (state, action) => {
        state.isLoading = false;
        state.contents = action.payload.contents;
        state.pagination = action.payload.pagination;
      })
      .addCase(getContents.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.message;
      })
      .addCase(getContent.fulfilled, (state, action) => {
        state.currentContent = action.payload;
      })
      .addCase(createContent.fulfilled, (state, action) => {
        state.contents.unshift(action.payload);
      })
      .addCase(updateContent.fulfilled, (state, action) => {
        const index = state.contents.findIndex(c => c._id === action.payload._id);
        if (index !== -1) state.contents[index] = action.payload;
      })
      .addCase(deleteContent.fulfilled, (state, action) => {
        state.contents = state.contents.filter(c => c._id !== action.payload);
      });
  }
});

export const { clearCurrentContent } = contentSlice.actions;
export default contentSlice.reducer;